import React, { useEffect } from 'react';
import {
  fileInputMultipleUI,
  fileInputMultipleSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { trackShaPageSeen } from '../utils/tracking/bddShaTracking';
import {
  UPLOAD_URL,
  FILE_UPLOAD_TITLE,
} from '../../shared/components/fileInputComponent/constants';
import { createPayload } from '../../shared/utils/fileInputMultiUIConfig';
import { additionalInfo } from '../../shared/components/fileInputComponent/AdditionalUploadInfo';
import {
  MAX_FILE_SIZE_BYTES,
  MAX_FILE_SIZE_MB,
  MAX_PDF_FILE_SIZE_BYTES,
  MAX_PDF_FILE_SIZE_MB,
} from '../../shared/constants';

const SHA_ACCEPTED_FILE_TYPES = '.pdf,.jpg,.jpeg,.png';
const SHA_ATTACHMENT_ID = 'L1839';
const SHA_HINT_TEXT = `You can upload .pdf, .jpg, .jpeg, or .png files. Each file should be no larger than ${MAX_FILE_SIZE_MB} MB for non-PDF files or ${MAX_PDF_FILE_SIZE_MB} MB for PDF files. Larger files may take longer to upload, depending on the internet connection.`;

const parseShaResponse = (response, file) => ({
  name: file?.name,
  confirmationCode: response?.data?.attributes?.guid,
  attachmentId: SHA_ATTACHMENT_ID,
  file,
});

/**
 * Tracks that the SHA upload page has been seen.
 * Rendered as part of ui:description so it fires on page mount.
 */
const ShaUploadDescription = () => {
  useEffect(() => {
    trackShaPageSeen('upload');
  }, []);

  return (
    <>
      <p>
        Upload your Separation Health Assessment (self-assessment, also called
        “Part A”) to support your claim.
      </p>
      {additionalInfo}
    </>
  );
};

export const uiSchema = {
  'ui:title': (
    <h3 className="vads-u-margin-y--0 vads-u-color--base">
      Upload your Separation Health Assessment
    </h3>
  ),
  'ui:description': <ShaUploadDescription />,
  separationHealthAssessmentUploads: {
    ...fileInputMultipleUI({
      title: FILE_UPLOAD_TITLE,
      required: true,
      skipUpload: false,
      fileUploadUrl: UPLOAD_URL,
      formNumber: '21-526EZ',
      fileSizesByFileType: {
        pdf: {
          maxFileSize: MAX_PDF_FILE_SIZE_BYTES,
          minFileSize: 1024,
        },
        default: {
          maxFileSize: MAX_FILE_SIZE_BYTES,
          minFileSize: 1,
        },
      },
      accept: SHA_ACCEPTED_FILE_TYPES,
      hint: SHA_HINT_TEXT,
      createPayload,
      parseResponse: parseShaResponse,
    }),
    'ui:confirmationField': ({ formData }) => ({
      data: formData?.map(item => item.name || item.fileName),
      label: 'Uploaded file(s)',
    }),
  },
};

export const schema = {
  type: 'object',
  required: ['separationHealthAssessmentUploads'],
  properties: {
    separationHealthAssessmentUploads: {
      ...fileInputMultipleSchema(),
      minItems: 1,
      maxItems: 20,
    },
  },
};
